import homeMobile from '../assets/home/background-home-mobile.jpg';
import homeTablet from '../assets/home/background-home-tablet.jpg';
import homeDesktop from '../assets/home/background-home-desktop.jpg';

import destinationMobile from '../assets/destination/background-destination-mobile.jpg';
import destinationTablet from '../assets/destination/background-destination-tablet.jpg';
import destinationDesktop from '../assets/destination/background-destination-desktop.jpg';

import crewMobile from '../assets/crew/background-crew-mobile.jpg';
import crewTablet from '../assets/crew/background-crew-tablet.jpg';
import crewDesktop from '../assets/crew/background-crew-desktop.jpg';

import techMobile from '../assets/technology/background-technology-mobile.jpg';
import techTablet from '../assets/technology/background-technology-tablet.jpg';
import techDesktop from '../assets/technology/background-technology-desktop.jpg';

import NotFound from '../assets/notFound.jpg';

export const homeImg = [homeMobile, homeTablet, homeDesktop];
export const destinationImg = [destinationMobile, destinationTablet, destinationDesktop];
export const crewImg = [crewMobile, crewTablet, crewDesktop];
export const techImg = [techMobile, techTablet, techDesktop];

export const Img404 = NotFound;
